module.exports = __webpack_public_path__ + "img/table-screen.71677693.svg";